import { GridColDef } from "@mui/x-data-grid";
import PartNumberCell from "../../componentes/fluxo-engenheiro/Requests/columns/partNumberCell";

const ROLE_LABEL = {
  admin: "Administrador de Engenharia",
  participant: "Participante",
} as const;

export const buildGroupParticipantsColumns = ({
  renderActions,
}: {
  renderActions: (row: any) => React.ReactNode;
}): GridColDef[] => [
  {
    field: "email",
    headerClassName: "header-table",
    renderHeader: () => <b className="partNumberColluns">Email</b>,
    renderCell: (params) => <PartNumberCell value={params.value as string} />,
    flex: 1.5,
  },
  {
    field: "role",
    headerClassName: "header-table",
    renderHeader: () => <b className="title-table">Papel</b>,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span className={`groupParticipantRole groupParticipantRole-${params.value}`}>
        {ROLE_LABEL[params.value as keyof typeof ROLE_LABEL] ?? params.value}
      </span>
    ),
    flex: 0.8,
  },
  {
    field: "acoes",
    headerClassName: "header-table",
    renderHeader: () => <b className="title-table">Ações</b>,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => renderActions(params.row),
    flex: 1,
  },
];